import { z } from 'zod';
import { LEAD_STATUSES } from '../constants/leadStatus.js';
import { LEGAL_BASIS_VALUES } from '../constants/legalBasis.js';
export const leadStatusSchema = z.enum(LEAD_STATUSES);
export const leadCreateSchema = z.object({
    project_id: z.string().uuid(),
    account_id: z.string().uuid().optional().nullable(),
    company: z.string().max(500).optional().nullable(),
    contact_name: z.string().max(500).optional().nullable(),
    email: z.string().email().optional().nullable(),
    phone: z.string().max(50).optional().nullable(),
    website: z.string().max(500).optional().nullable(),
    job_title: z.string().max(200).optional().nullable(),
    linkedin_url: z.string().max(500).optional().nullable(),
    status: leadStatusSchema.optional(),
    tags: z.array(z.string().max(64)).max(50).optional(),
    notes: z.string().max(10000).optional().nullable(),
    outreach_reason: z.string().max(2000).optional().nullable(),
    legal_basis: z.enum(LEGAL_BASIS_VALUES).optional().nullable(),
    do_not_contact: z.boolean().optional(),
    consent_at: z.string().datetime().optional().nullable(),
    custom_fields: z.record(z.string(), z.unknown()).optional(),
    timezone: z.string().min(1).max(64).optional().nullable(),
});
export const leadUpdateSchema = leadCreateSchema.partial().omit({ project_id: true });
export const leadListQuerySchema = z.object({
    project_id: z.string().uuid().optional(),
    status: leadStatusSchema.optional(),
    source: z.string().optional(),
    tag: z.string().optional(),
    q: z.string().max(200).optional(),
    page: z.coerce.number().int().min(1).default(1),
    page_size: z.coerce.number().int().min(1).max(100).default(25),
});
export const leadNoteSchema = z.object({
    body: z.string().min(1).max(5000),
});
export const leadBulkPatchSchema = z.object({
    project_id: z.string().uuid(),
    lead_ids: z.array(z.string().uuid()).min(1).max(200),
    status: leadStatusSchema.optional(),
    add_tags: z.array(z.string().max(64)).max(20).optional(),
    remove_tags: z.array(z.string().max(64)).max(20).optional(),
    do_not_contact: z.boolean().optional(),
});
export const leadWebsiteScanBodySchema = z.object({
    replace_existing: z.boolean().optional().default(false),
});
export const leadWebsiteScanBulkSchema = z.object({
    project_id: z.string().uuid(),
    lead_ids: z.array(z.string().uuid()).min(1).max(100),
    replace_existing: z.boolean().optional().default(false),
});
//# sourceMappingURL=lead.js.map